class InvalidPostMessageEventException extends Error {
	constructor(event) {
		super("Invalid PostMessage Event.");
		this.event = event;
		this.name = "InvalidPostMessageEventException";
	}
}

export default InvalidPostMessageEventException;
